import { useEffect } from "react";

const SITE_NAME = "MathMinds";
const SITE_URL = "https://mathmindsgame.com";

function upsertMeta(name, content) {
    let element = document.head.querySelector(`meta[name="${name}"]`);
    if (!element) {
        element = document.createElement("meta");
        element.setAttribute("name", name);
        document.head.appendChild(element);
    }
    element.setAttribute("content", content);
}

function upsertLink(rel, href) {
    let element = document.head.querySelector(`link[rel="${rel}"]`);
    if (!element) {
        element = document.createElement("link");
        element.setAttribute("rel", rel);
        document.head.appendChild(element);
    }
    element.setAttribute("href", href);
}

export default function usePageMetadata({ title, description, canonicalPath = window.location.pathname }) {
    useEffect(() => {
        document.title = title.includes(SITE_NAME) ? title : `${title} | ${SITE_NAME}`;
        upsertMeta("description", description);
        upsertLink("canonical", new URL(canonicalPath, SITE_URL).href);
    }, [canonicalPath, description, title]);
}
